import api from '@/api';

import { PageResult } from '@/core/request/PageResult';

import {
  ListGroupsQuery,
  Group,
  CreateGroupRequest,
  UpdateGroupRequest,
  ListGroupsReducedQuery,
  GroupReduced,
} from './Groups.types';

import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/groups`;

export async function listGroups(
  params: ListGroupsQuery,
): Promise<PageResult<Group>> {
  const result = (await api.get(`${CONTROLLER_URL}`, params)) as unknown;

  return result as PageResult<Group>;
}

export async function listGroupsReduced(params: ListGroupsReducedQuery) {
  const result = (await api.get(
    `${CONTROLLER_URL}/search-group`,
    params,
  )) as unknown;

  return result as PageResult<GroupReduced>;
}

export async function getGroup(id: number): Promise<Group> {
  const result = (await api.get(`${CONTROLLER_URL}/${id}`, null)) as unknown;

  return result as Group;
}

export async function createGroup(obj: CreateGroupRequest): Promise<Group> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Group;
}

export async function updateGroup(obj: UpdateGroupRequest): Promise<Group> {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as Group;
}

export async function deleteGroup(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function groupActivateOrInactivate(groupId: number) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${groupId}/activate`,

    {},

    null,
  )) as unknown;

  return result;
}
